import React from "react";

const Annual = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M31.092 3.221h-1.099c.028-.09.057-.181.057-.282a.938.938 0 10-1.878 0c0 .1.027.192.058.282h-3.596c.028-.09.057-.181.057-.282a.94.94 0 00-1.88 0c0 .1.028.192.057.282h-3.595c.028-.09.056-.181.056-.282a.94.94 0 00-1.879 0c0 .1.029.192.057.282h-3.596a.937.937 0 00.057-.282.94.94 0 00-1.879 0c0 .1.027.192.057.282H8.55a.907.907 0 00.057-.282.939.939 0 10-1.878 0c0 .1.028.192.056.282H5.687A2.69 2.69 0 003 5.908v25.405A2.689 2.689 0 005.687 34h22.37l5.722-5.72V5.907a2.689 2.689 0 00-2.687-2.687zM5.687 32.534a1.223 1.223 0 01-1.221-1.221V12.748h27.847v14.923l-.304.304h-2.302a1.96 1.96 0 00-1.954 1.954v2.302l-.303.303H5.687z"
            fill={fill}
        />
        <path className="u_fill"
            d="M9.53 23.33l2.252.931-.477.223a.285.285 0 00-.135.367l.65 1.394c.03.069.09.123.16.148.07.03.149.03.218 0l4.938-2.316.062-.657.087-.879a.21.21 0 01.402-.068c.019.032.027.07.024.108l-.572 6.065a.568.568 0 00.443.098c.218-.058.412-.313.572-.733l2.291-6.816.066-.194a.215.215 0 11.412.121l-.006.016-.223.653-.252.75 3.867-1.812c1.117-.521 1.691-1.578 1.306-2.402a1.448 1.448 0 00-1.12-.781 2.66 2.66 0 00-1.563.24l-4.38 2.044-4.7-1.835c-.592-.223-1.062-.218-1.39.02a1.169 1.169 0 00-.427.925c.002.09.048.174.122.225l3.167 2.17-1.815.86-3.044-.762a.288.288 0 00-.317.137l-.755 1.357a.286.286 0 00.109.39l.028.014zM12.33 8.777c0 .19.126.285.292.285a.406.406 0 00.386-.274.531.531 0 00.015-.127v-.259c-.39-.007-.694.087-.694.375zM20.986 8.777c0 .19.127.285.293.285a.408.408 0 00.387-.274.531.531 0 00.015-.127v-.259c-.392-.007-.695.087-.695.375z"
            fill={fill}
        />
    </svg>
);

export default Annual;